// Generated by Claude Code
import { createIcon } from '#components/primitives/icons/create-icon.ts'

const UserFilled = createIcon(
  'user-filled',
  {
    line: [
      'M8 7C8 9.209 9.791 11 12 11C14.209 11 16 9.209 16 7C16 4.791 14.209 3 12 3C9.791 3 8 4.791 8 7ZM6 21C6 17.686 8.686 15 12 15C15.314 15 18 17.686 18 21',
    ],
    fill: [
      'M7 7C7 4.239 9.239 2 12 2C14.761 2 17 4.239 17 7C17 9.761 14.761 12 12 12C9.239 12 7 9.761 7 7ZM18 22H6C5.448 22 5 21.552 5 21C4.997 20.064 5.185 19.137 5.551 18.275C5.901 17.443 6.41 16.687 7.05 16.05C8.367 14.734 10.138 13.996 12 14C13.862 14 15.636 14.731 16.95 16.05C17.59 16.687 18.099 17.443 18.449 18.275C18.815 19.137 19.003 20.064 19 21C19 21.552 18.552 22 18 22Z',
    ],
  },
  'fill',
)

export default UserFilled
